import { create } from "zustand";
import type { StateCreator } from "zustand";

import { UserInfoDTO } from "@/common/api";

type NullableUser = UserInfoDTO | null;

export interface UserState {
  user: NullableUser;
}

export interface UserActions {
  setUser: (user: NullableUser) => void;
}

export type UserStore = UserState & UserActions;

const createUserStore: StateCreator<UserStore> = (set) => ({
  user: null,
  setUser: (user) => set({ user }),
});

export const useUserStore = create<UserStore>(createUserStore);
